import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { DashBoardActions } from "../../../store/ducks/dashboard";

export const useLoadPatientSelectOptions = (isOpen: boolean) => {
	const dispatch = useDispatch();

	useEffect(() => {
		if (!isOpen) return;

		dispatch(DashBoardActions.sync_porta_entrada_request());
		dispatch(DashBoardActions.gerencias_request());
		dispatch(DashBoardActions.cargos_request());
	}, [dispatch, isOpen]);
};
